export const PRICE_LADDER_MODEL = "Price_piano_model";